var map = {
	"./images/pexels-math-331684.jpg": 21,
	"./projects/LoConnected.png": 40,
	"./projects/Suviba.png": 41,
	"./projects/dbArte.png": 42,
	"./svg/email.svg": 20,
	"./svg/github.svg": 14,
	"./svg/hobbies/books.svg": 22,
	"./svg/hobbies/desktop.svg": 23,
	"./svg/hobbies/synthesizer.svg": 24,
	"./svg/instagram.svg": 43,
	"./svg/linkedin.svg": 19,
	"./svg/navbar.svg": 18,
	"./svg/right-arrow.svg": 25,
	"./svg/wave-haikei.svg": 44,
	"./svg/whatsapp.svg": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;